export default __webpack_public_path__ + "static/media/MillImg.21cfccb9.jpg";